export enum AcceptPaymentMethodEnum {
    UPI = "upi", 
    BankAccount = "bankAccount"
}